import { Button } from "@heroui/react";
import { useNavigate, useSearchParams } from "react-router-dom";

export function AuthErrorPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const code = params.get("code") ?? "AUTHENTICATION_FAILED";

  return (
    <main className="grid min-h-screen place-items-center bg-soft p-6">
      <section className="w-full max-w-xl rounded-[2.5rem] border border-white/80 bg-white/80 p-6 text-center shadow-xl shadow-pink-200/40 backdrop-blur sm:p-10">
        <img
          alt="A cheerful poodle wearing heart-shaped sunglasses"
          className="mx-auto aspect-square w-full max-w-sm rounded-[2rem] object-cover shadow-lg shadow-pink-200/50"
          src="/images/poodle-signin-error.png"
        />
        <h1 className="mt-8 text-3xl font-semibold tracking-tight sm:text-4xl">
          Boof, that's a signin error.
        </h1>
        <p className="mt-3 text-sm text-muted">Error code: {code}</p>
        <Button
          className="mt-7"
          onPress={() => navigate("/signin", { replace: true })}
        >
          Try again
        </Button>
      </section>
    </main>
  );
}
